import DashboardAppPage from 'src/pages/Dashboard';
import { Navigate, Route, Routes } from 'react-router-dom';
import DashboardLayout from 'src/layouts/dashboard/DashboardLayout';
import BookingPage from 'src/pages/Booking';
import BookingDetailsPage from 'src/pages/BookingDetailsPage';

export default function DriverRouter() {
  return (
    <Routes>
      <Route path="*" element={<Navigate to={`/`} replace />} />
      <Route element={<DashboardLayout />}>
        <Route path="/" element={<DashboardAppPage />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/booking-details" element={<BookingDetailsPage />} />
      </Route>
    </Routes>
  );
}
